import Store from "App/Store.js";

export default seatReservationDialog => {
	Store.dispatch({type: "seatReservationDialog", seatReservationDialog});
};
